import * as React from "react";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkCheckbox } from "uitk-react-switch";
import { BookRoundtripToggleProps } from "../../typings";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../l10n";

export const BookRoundtripToggle: React.FunctionComponent<BookRoundtripToggleProps> = (props) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox id="book-roundtrip-toggle" onChange={props.toggleBookRoundtrip} checked={props.roundTripChecked}>
          {formatText(locKeys.gtRoundtrip)}
        </UitkCheckbox>
        <input
          type="hidden"
          name="roundTrip"
          value={props.roundTripChecked.toString()}
          data-testid="book-roundtrip-input"
        />
      </div>
    </UitkLayoutGridItem>
  );
};
